export const blockIconsHardwareKeyboardArrowRightNew = (
	<span className='material-symbols-outlined'>keyboard_arrow_right</span>
);
